<template>
  <footer class="bg-primary py-6 text-center text-sm text-white">
    Powered by Relo Create, Ltd.
  </footer>
</template>
